(function () {
	// Function to set picture opacity
	function setPictureOpacity(picture, opacity) {
		picture.style.opacity = opacity;
	}

	// Function to handle image load
	function handleImageLoad(event) {
		console.log("Image loaded:", event.target.src);
		const img = event.target;
		const picture = img.closest("picture");

		// Remove this event listener
		img.removeEventListener("load", handleImageLoad);

		// Check if all images in this picture are loaded
		const allImagesLoaded = Array.from(picture.querySelectorAll("img")).every(
			(img) => img.complete
		);

		if (allImagesLoaded) {
			setPictureOpacity(picture, 1);
		}
	}

	// Function to initialize pictures
	function initializePictures() {
		console.log("Initializing pictures");
		const pictures = document.querySelectorAll("picture");

		pictures.forEach((picture) => {
			const images = picture.querySelectorAll("img");

			if (images.length > 1) {
				// Set initial opacity to 0
				setPictureOpacity(picture, 0);

				// Check if all images are already loaded (e.g., from cache)
				const allImagesLoaded = Array.from(images).every((img) => img.complete);

				if (allImagesLoaded) {
					// If all images are loaded, set opacity to 1 immediately
					setPictureOpacity(picture, 1);
				} else {
					// Add load event listeners to images
					images.forEach((img) => {
						if (!img.complete) {
							img.addEventListener("load", handleImageLoad);
						}
					});
				}
			}
		});
	}

	// Run initialization immediately
	initializePictures();

	// Run again after a short delay to catch any pictures that might have been added dynamically
	setTimeout(initializePictures, 0);

	// Also run on DOMContentLoaded to ensure we don't miss anything
	document.addEventListener("DOMContentLoaded", initializePictures);

	// MutationObserver to watch for dynamically added pictures
	const observer = new MutationObserver((mutations) => {
		mutations.forEach((mutation) => {
			if (mutation.type === "childList") {
				mutation.addedNodes.forEach((node) => {
					if (
						node.nodeType === Node.ELEMENT_NODE &&
						(node.tagName === "PICTURE" || node.querySelector("picture"))
					) {
						initializePictures();
					}
				});
			}
		});
	});

	observer.observe(document.body, { childList: true, subtree: true });
})();
